import { render, staticRenderFns } from "./item-form-modal.vue?vue&type=template&id=b76ae1da&"
import script from "./item-form-modal.vue?vue&type=script&lang=js&"
export * from "./item-form-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports